module.exports = __webpack_public_path__ + "static/iwth-fr-footer-95a9389b42d1191ef37f346da5ef81d5.svg";